import React, {Component} from 'react'
import { Row, Col } from 'react-bootstrap'
import PrintPreview from 'view/print/PrintPreview'
import PdfStore from 'stores/PdfStore'
import '../Print.css'
var number_format = require('number-format.js')

const month_full = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤษจิกายน", "ธันวาคม"]
const ACTIVE_COLUMN = 8
const ROW_PER_PAGE = 55
const BREAK_HEADER_START = 8
const BREAK_HEADER_END   = 21
class PrintExcelQuotationDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {page_title:'กำลังดึงข้อมูล..',defaultTypePrint:'3',loading:false, data:{workbook:{data:[],colWidths:[],cell:[],mergeCells:[]}}}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData(){
    let {data} = this.state
    this.setState({loading:true})
    
    if(this.props.fileId!==''){
      PdfStore.loadQuotationFileDoc(this.props.fileId,this.props.mode,this.props.sheetId,(result)=>{
      
        let newData = result.data
        //console.log('data',data)
        this.setState({loading:false,data:newData})
      },()=>{
        this.setState({loading:false})
      })
    }else if(this.props.qoNo!==''){
      PdfStore.loadQuotationDoc(this.props.qoNo,(result)=>{
        let data = result.data

        this.setState({loading:false,data:data})
      },function(){
        this.setState({loading:false})
      })
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }

    if(logoUrl!==undefined)
      return (<img src={imgUrl} style={{maxHeight:'100px'}}/>)
    else
      return ('')
  }

  

  getCellStyle(cell,row,col,colspan){
    let style = {}
    
    let remIndex = cell.findIndex((item)=> {
      return (item.row===row && item.col===col);
    });
    if(remIndex>=0){
      let item = cell[remIndex];
      if(item.className==='htCenter'){
        style = {textAlign:'center'}
      }else if(item.className==='htRight'){
        style = {textAlign:'right'}
      }

      if(item.numberFormat!==undefined){
        //_-* #,##0_-;\\-* #,##0_-;_-* \"-\"??_-;_-@_-
        //_-* #,##0.00_-;\\-* #,##0.00_-;_-* \"-\"??_-;_-@_-
        //
        let decimal = '#,##0.####'
        let index = item.numberFormat.indexOf('##0.00')
        if(index>0){
          decimal = '#,##0.00'
        }
        style = Object.assign(style,{numberFormat:decimal})
      }

      if(item.fill!==undefined){
        let hex = item.fill.color.rgb.replace('FF','#')
        style = Object.assign(style,{background:hex})
      }
      
      if(item.borderStyle.right!==undefined){
        style = Object.assign(style,{borderRight:'1px solid #000'})
      }
      if(item.borderStyle.bottom!==undefined){
        style = Object.assign(style,{borderBottom:'1px solid #000'})
      }

      remIndex = cell.findIndex((fitem)=> {
        return (fitem.row===row && fitem.col===col-1);
      });
      if(remIndex<0 || cell[remIndex].borderStyle.right===undefined){
        
        if(item.borderStyle.left!==undefined){
          style = Object.assign(style,{borderLeft:'1px solid #000'})
        }
      }

      remIndex = cell.findIndex((fitem)=> {
        return (fitem.row===row-1 && fitem.col===col);
      });
      if(remIndex<0 || cell[remIndex].borderStyle.bottom===undefined ){
        
        if(item.borderStyle.top!==undefined){
          style = Object.assign(style,{borderTop:'1px solid #000'})
        }
      }
      

    }else{
      //style = Object.assign(style,{whiteSpace:'nowrap'})
    }

    if(colspan>1){
      col = col + colspan - 1
      let remIndex = cell.findIndex((item)=> {
        return (item.row===row && item.col===col);
      });
      if(remIndex>=0){
        let item = cell[remIndex];
        if(item.borderStyle.right!==undefined){
          style = Object.assign(style,{borderRight:'1px solid #000'})
        }
      }
    }
    return style
  }

  getColSpan(cell,row,col){
    let style = 0
    
    let remIndex = cell.findIndex((item)=> {
      return (item.row===row && item.col===col);
    });
    if(remIndex>=0){
      return cell[remIndex].colspan;      
    }
    return style
  }

  renderSpace(col){
    if(col!==null && typeof col === 'string' ){

      col=col.replace(/ /g,"&nbsp;");  
      //return (<div dangerouslySetInnerHTML={{__html: col}} />)
    }
    
    return col
  }

  renderColumnData(col,rindex,cindex,colSpan){
    let {data} = this.state
    let {workbook} = data
    let {cell,mergeCells} = workbook
               
    // let style =  {}
    // if(cindex<colWidths.length){
    //   style = {width:colWidths[cindex]+'px'}
    // }
    
    let style = this.getCellStyle(cell,rindex,cindex,colSpan)
    if(style.numberFormat!==undefined && col!==null && col!=='' && col>0){
      if(style.textAlign===undefined)
        style = Object.assign(style,{textAlign:'right'})
      
      col = number_format(style.numberFormat,col);  
    }
    return (<td className={colSpan==3&&col!=null&&col.indexOf('ถ้วน')!=-1?'bg-green-print':''} key={cindex} style={style} colSpan={colSpan} dangerouslySetInnerHTML={{__html:this.renderSpace(col)}}>    
    </td>)
  }

  renderRowColumnData(row,rindex){
    let {data} = this.state
    let {workbook} = data
    let {mergeCells} = workbook
    let cdata = []
    if(row.length<ACTIVE_COLUMN){
      row = row.concat(new Array(ACTIVE_COLUMN-row.length).fill(''))
    }
    
    for(let cindex=0;cindex<row.length && cindex<ACTIVE_COLUMN;cindex++){
      let colSpan = this.getColSpan(mergeCells,rindex,cindex)
      
      cdata.push(this.renderColumnData(row[cindex],rindex,cindex,colSpan))
  
      if(colSpan>0)
        cindex += colSpan-1        
    }
    return cdata;
  }

  renderRowData(start,end){
    let {data} = this.state
    let {workbook} = data
    //Script row
        
    return workbook.data.map((row,rindex)=>{
      if(rindex<BREAK_HEADER_START){
        return ('')
      }      
      if(rindex>=BREAK_HEADER_START && rindex <=BREAK_HEADER_END){
        //OK
        //Always Pass    
      }else{
        if(start > rindex || rindex>end){
          return ('')
        }         
      }
      return (
        <tr key={rindex}>
          {
            
            this.renderRowColumnData(row,rindex)
          }
        </tr>
      )      
    
      
    })
  }

  renderColGroup(){
    let {data} = this.state
    let {workbook} = data
    let {colWidths} = workbook
    let style =  {}
    
    let totalWidth = 0;
    for(let ind=0;ind<colWidths.length&&ind<ACTIVE_COLUMN;ind++){
      totalWidth += colWidths[ind]*1      
    }

    let cols = []    
    for(let ind=0;ind<colWidths.length&&ind<ACTIVE_COLUMN;ind++){
      
      let width = Math.ceil(678* colWidths[ind]/totalWidth)
      style = {width:width+'px'}
      
      cols.push((<col key={ind} style={style}></col>))
    }

    return cols
  }

  renderComponentPage(start,end,itemlist,itemIndex) {
    let {data,defaultTypePrint} = this.state
    
     return (
      <div className='excel-quotation-doc font-print '>
        <header style={{display:'none'}}>
          <h2 className="text-right">{'ใบเสนอราคา'}</h2>
        </header>  
        <article  style={{display:''}} className={"article-company "+data.logo_class}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-18" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
              <p style={{lineHeight:'0.7'}}>รับ เคาะ ปะผุ พ่นสี รถยนต์ ทุกชนิด รับขึ้นตัวถังตู้แห้ง  และกระบะรถบรรทุก</p>               
              <p style={{lineHeight:'0.7'}}>รับดัดครัซซี  และรับพ่นทรายงานทุกประเภท  รับซ่อมเครื่องยนต์ และระบบช่วงล่างรถทุกชนิด</p>              
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax} {data.company_mobile!==undefined?'มือถือ '+data.company_mobile:''} เลขที่ผู้เสียภาษี {data.company_tax}</p>              
            </strong>
          </section>
          <section className='text-right sec-copy-doc'>
            <div className='qo-no'>
              เลขที่ <br/>
              {data.quotation_no} 
            </div> 
            <span style={{display:defaultTypePrint=='0'?'none':''}}>{itemlist.type=='ori'?'ต้นฉบับ':itemlist.type=='copy'?'สำเนา':''}</span>  
          </section>
        </article>
        <div className="box-quotation-doc font-16 handsontable">
          <div>
            <table className='table-layout-fixed htCore'>
              <colgroup>
                {this.renderColGroup()}
              </colgroup>
              <tbody>
                {this.renderRowData(start,end)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
        )
    
  }

  


  addNewLine(val){
    let valLine = val.split('\\n')
    return valLine.map(function(item, key) {
      return (
        <span key={key} className='remark-content'>
          {item}
          <br/>
        </span>
      )
    })
  }

  addLineBreak(val) {
    const divStyle = {
      whiteSpace: 'pre-line'
    }
    
    return (
      <div style={divStyle}>
        {this.addNewLine(val)}
      </div>
    )
  }


  onTypePrintChange(e) {
  	this.setState({defaultTypePrint:e})  
  }

  setPageRender(dataList,defaultTypePrint) {
    let pages = []
    dataList.forEach((item,index)=>{
        if (defaultTypePrint=='1'||defaultTypePrint=='3'||defaultTypePrint=='0') {
            pages.push({
                page:index+1,
                type:'ori',
                data:item
            })
        } else if (defaultTypePrint=='2') {
            pages.push({
                page:index+1,
                type:'copy',
                data:item
            })
        }
    })
    if (defaultTypePrint=='3'||defaultTypePrint=='0') {
        pages.forEach((item,index)=>{
            pages.push({
                page:pages[pages.length-1].page+1,
                type:'copy',
                data:item.data
            })
        })
    }
    return pages
  }

  checkEmptyPage(start,end){
    let {loading,data} = this.state
    let {workbook} = data
    let emptyPage = true
    for(let rindex=start;rindex<end;rindex++){
      let row = workbook.data[rindex]
      if(row.length>0){
        let fIndex = row.findIndex((item,index)=>{
          return (item!=='' && item!==null && index < ACTIVE_COLUMN)
        });
        if(fIndex>=0){
          emptyPage = false
        }
      }
    }
    return emptyPage
  }

  setPageRender(dataList,defaultTypePrint) {
    let pages = []
    dataList.forEach((item,index)=>{
        if (defaultTypePrint=='1'||defaultTypePrint=='3'||defaultTypePrint=='0') {
            pages.push({
                page:index+1,
                type:'ori',
                data:item
            })
        } else if (defaultTypePrint=='2') {
            pages.push({
                page:index+1,
                type:'copy',
                data:item
            })
        }
    })
    if (defaultTypePrint=='3'||defaultTypePrint=='0') {
        pages.forEach((item,index)=>{
            pages.push({
                page:pages[pages.length-1].page+1,
                type:'copy',
                data:item.data
            })
        })
    }
    return pages
  }

  render() {
    let {loading,data,defaultTypePrint} = this.state
    let {workbook} = data

    let startRow = 0
    let pages = []
    for(let rindex=0;rindex<workbook.data.length;rindex++){
      let emptyRow = true
      let row = workbook.data[rindex]
      row.map((col,index)=>{
        if(col===''){
          emptyRow = true
        }else{
          emptyRow = false
        }
        return col
      })
      
      if(emptyRow && startRow===0){
        
      }else{
        //Start hear
        startRow = -1
        let end = rindex + ROW_PER_PAGE
        if(end > workbook.data.length){
          end = workbook.data.length  -1
        }
        if(rindex!==end){
          let empty = this.checkEmptyPage(rindex,end)
          if(!empty)
            pages.push({start:rindex,end:end})
        }
        rindex = end
      }
    }
    let new_pages = this.setPageRender(pages,defaultTypePrint)
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบเสนอราคา '+this.props.qoNo}
        onTypePrintChange={this.onTypePrintChange.bind(this)}
        defaultTypePrint={this.state.defaultTypePrint}
        showPageNumber={false}
      >
        {          
          new_pages.map((item,index)=>{
            return this.renderComponentPage(item.data.start,item.data.end,item,index)
          })           
        }
      </PrintPreview>
    )
  }

}  

PrintExcelQuotationDoc.defaultProps = {
  title: 'ใบเสนอราคา',  
  mode : 'excel',
  fileId: '',
  qoNo:'',
  sheetId:0
}
export default PrintExcelQuotationDoc;


// WEBPACK FOOTER //
// ./src/view/print/kkc/PrintExcelQuotationDoc.js